import React, {ChangeEventHandler, FC} from 'react';
import classes from './input.module.sass'

interface Props {
    label: string;
    name: string;
    value: string;
    onChange: ChangeEventHandler<HTMLInputElement>;
    className: string;
}

const Input: FC<Props> = (
    {
        label,
        value,
        onChange,
        name,
        className
    }
) => {
    return (
        <label className={classes.input + ' ' + className}>
            <span>{label} <span>*</span></span>
            <input name={name} value={value} onChange={onChange} />
            {className === 'invalid'
                ? value.length !== 0
                    ? <span className={className + ' ' + 'span'}>Invalid format</span>
                    : <span className={className + ' ' + 'span'}>Required field</span>
                : null
            }
        </label>
    );
};

export default Input;